// src/pages/Home.js
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import CMSRenderer from '../components/cms/CMSRenderer';
import HeroCarousel from '../components/HeroCarousel';
import HomeButtons from '../components/HomeButtons';
import FullBleed from '../components/FullBleed';
import bg from '../assets/card.png';

axios.defaults.withCredentials = true;

const TOP_SAFE  = 100;
const SIDE_GAP  = 24;

export default function Home() {
  const navigate = useNavigate();
  const loc = useLocation();
  const [profile, setProfile] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('home_profile')||'null'); }
    catch { return null; }
  });
  const [slides, setSlides] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('home_slides')||'[]'); }
    catch { return []; }
  });
  const [cmsPage, setCmsPage] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('home_cms_page') || 'null'); }
    catch { return null; }
  });
  const [cmsError, setCmsError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/api/member/profile');
        setProfile(data); sessionStorage.setItem('home_profile', JSON.stringify(data));
      } catch {
        setProfile(null);
        // 未登入 → 強制導去登入頁（帶上 from，登入後可導回）
       const from = loc.pathname + loc.search;
       navigate(`/link?from=${encodeURIComponent(from)}`, { replace: true });
       return; // 直接結束，後面就不載入輪播
      }
      try {
        const { data } = await axios.get('/api/slides/home');
        const list = (data?.slides || []).map(s => ({ src:s.src, alt:s.alt||'' }));
        setSlides(Array.isArray(list) ? list : []);
        sessionStorage.setItem('home_slides', JSON.stringify(list));
      } catch {
       // 輪播抓失敗就算了，不影響登入；不要在這裡導轉
       setSlides([]);
      }

      // 首頁 CMS：若存在已發佈的 slug=home，直接以 CMS 區塊渲染
      try {
        setCmsError('');
        const { data } = await axios.get('/api/public/cms/by-slug', { params: { slug: 'home' } });
        if (data?.page) {
          setCmsPage(data.page);
          sessionStorage.setItem('home_cms_page', JSON.stringify(data.page));
        } else {
          setCmsPage(null);
        }
      } catch (e) {
        setCmsError(e?.response?.data?.error || 'not_found');
      }
    })();
  }, [loc.pathname, loc.search, navigate]);

  const openExternal = (url) => {
    if (openExternal._busy) return;
    openExternal._busy = true;
    setTimeout(() => (openExternal._busy = false), 800);
    try {
      const liff = window.liff;
      if (liff?.isInClient?.()) { liff.openWindow({ url, external: true }); return; }
    } catch {}
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const cmsBlocks = useMemo(() => (Array.isArray(cmsPage?.content) ? cmsPage.content : []), [cmsPage]);
  const hasCmsHome = cmsBlocks.length > 0 && !cmsError;

  const contentPad = {
    paddingLeft: `calc(${SIDE_GAP}px + env(safe-area-inset-left, 0px))`,
    paddingRight: `calc(${SIDE_GAP}px + env(safe-area-inset-right, 0px))`,
  };

  if (hasCmsHome) {
    return (
      <CMSRenderer
        blocks={cmsBlocks}
        pageTitle={cmsPage?.title || '首頁'}
        pageDesc={cmsPage?.seo_desc || ''}
      />
    );
  }

  return (
    <FullBleed bg={bg}>
      <div style={{ height: `calc(${TOP_SAFE}px + env(safe-area-inset-top, 0px))` }} />
      <div style={contentPad}>
        <section style={{ marginBottom: 12 }}>
          {slides.length === 0
            ? <div style={{height:180, borderRadius:16, background:'rgba(0,0,0,.06)'}} />
            : <HeroCarousel slides={slides} aspectRatio="16/9" title="最新消息" />}
        </section>

        {/* 夜間按鈕所有人可見；點了進卡頁由卡頁處理付款/顯示 */}
        <HomeButtons canNight={true} openExternal={openExternal} />
      </div>
    </FullBleed>
  );
}
